import { CustomModal } from '@publicisgroupe/p-os-components';
import { CookieBanner } from 'components/CookieBanner/CookieBanner';
import { useCallback } from 'react';
import { Transition } from 'semantic-ui-react';
import './CookieBannerModal.less';

interface CookieBannerModalProps {
  open: boolean;
  closeModal: (val?: boolean) => void;
  canClose: boolean;
}
export const CookieBannerModal = ({ open, closeModal, canClose }: CookieBannerModalProps) => {
  const handleCloseModal = useCallback(() => {
    if (canClose) closeModal();
  }, [canClose, closeModal]);

  return (
    <>
      <Transition.Group animation="fly right" duration={800} directional>
        {open && (
          <CustomModal
            open={true}
            onClose={handleCloseModal}
            size="tiny"
            className="cookie-banner"
            closeIcon={canClose ? undefined : false}
            centered
          >
            <CustomModal.Content>
              <CookieBanner closeBanner={handleCloseModal} />
            </CustomModal.Content>
          </CustomModal>
        )}
      </Transition.Group>
    </>
  );
};
